import "./adminListInvoices.scss";
import { DataList, DataListColumn, StatusBadge, MoneyValue } from "../../../components/ui";

interface InvoiceRow {
    client: string;
    asset: string;
    amount: number;
    hashLabel: string;
    date: string;
    status: string;
}

// MOCK temporario — substituir por dispatch quando store estiver pronto
const MOCK_ROWS: InvoiceRow[] = [
    { client: "Peter", asset: "Tether", amount: 300000, hashLabel: "Detalhes da Transacao", date: "27/12/2026", status: "completed" },
];

const AdminListInvoices = () => {
    const columns: DataListColumn<InvoiceRow>[] = [
        { key: "client", header: "Cliente",    render: (r) => r.client },
        { key: "asset",  header: "Asset",      render: (r) => r.asset },
        { key: "amount", header: "Quantidade", render: (r) => <span><span style={{ opacity: .6, fontSize: ".75rem" }}>USDT</span> <MoneyValue amount={r.amount} tone="neutral" /></span>, align: "right" },
        { key: "hash",   header: "Hash",       render: (r) => <a href="#">{r.hashLabel}</a> },
        { key: "date",   header: "Data",       render: (r) => r.date, mono: true },
        { key: "status", header: "Status",     render: (r) => <StatusBadge status={r.status} /> },
    ];

    return (
        <div className="admin-client-invoices-wrapper">
            <h1 className="page-title">
                Listar Envios
                <small>lista de todos os envios realizados.</small>
            </h1>

            <DataList
                columns={columns}
                rows={MOCK_ROWS}
                empty="Nenhum envio encontrado."
            />
        </div>
    );
};

export default AdminListInvoices;
